var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-edit-info"},[_c('svgicon',{attrs:{"name":"Controls/Check"}}),_vm._v("\n  "+_vm._s(_vm.successInfoText)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }